import cancelError from './cancelError';

export default class Completer<T> {
  constructor() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let _resolve: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let _reject: any;
    this.promise = new Promise<T>((resolve, reject) => {
      _resolve = resolve;
      _reject = reject;
    });
    this.resolve = _resolve;
    this.reject = _reject;
  }

  promise: Promise<T>;

  resolve: (value: T | PromiseLike<T> | undefined) => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reject: (reason?: any) => void;

  cancel() {
    this.reject(cancelError);
  }

  static isCancel(error: Error) {
    return error === cancelError;
  }
}
